module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/surgicals/img03-166d62c981e67dd34bb6e8bb381bb1bd.png";